import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Form, FormGroup } from 'reactstrap';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import FormItem from '../../../common/forms/FormItem';
import TextInput from '../../../common/forms/input/TextInput';
import Select from '../../../common/forms/select/Select';
import { enumToSelectOptions } from '../../../../utils/enum';
import { isRequired } from '../../../../utils/validators';
import { CREDIT_NOTE_MOTIVES_TICKET } from '../../../../config/constants';
import FormFooter from '../../../common/forms/FormFooter';
import Alert from '../../../common/informative/Alert';
import { numberFormatter } from '../../../../utils/number';

const selector = formValueSelector('TicketPostponeForm');

export const TicketPostponeForm = ({
  handleSubmit,
  onCancel,
  message,
  creditNoteMotiveValue,
  ticket,
}) => {
  const hasCreditNoteTotalAmount =
    ticket && ticket.creditNoteTotalAmount != null && ticket.salePrice != null;

  let availableToPostpone = null;

  if (hasCreditNoteTotalAmount) {
    availableToPostpone = ticket.salePrice - ticket.creditNoteTotalAmount;
  }

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <p>{message}</p>

        <hr />

        {hasCreditNoteTotalAmount && (
          <Alert
            type="info"
            message={`Total disponible para postergar: ${numberFormatter({
              value: availableToPostpone,
            })}`}
          />
        )}

        <FormGroup row>
          <FormItem label="Motivo de Generación" required>
            <Field
              name="creditNoteMotive"
              component={Select}
              options={enumToSelectOptions(CREDIT_NOTE_MOTIVES_TICKET)}
              placeholder="Motivo de Generación"
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>
        {creditNoteMotiveValue &&
          creditNoteMotiveValue.value ===
            CREDIT_NOTE_MOTIVES_TICKET.OTHERS.value && (
            <FormGroup row>
              <FormItem label="Observación de Generación" required>
                <Field
                  name="creditNoteMotiveDescription"
                  component={TextInput}
                  type="textarea"
                  placeholder="Observación de Generación"
                  validate={[isRequired]}
                />
              </FormItem>
            </FormGroup>
          )}

        <FormFooter saveButtonColor="info" saveButtonText="Modificar">
          <Button color="primary" onClick={onCancel}>
            Cancelar
          </Button>
        </FormFooter>
      </Form>
    </>
  );
};

TicketPostponeForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  message: PropTypes.string,
  creditNoteMotiveValue: PropTypes.instanceOf(Object),
  ticket: PropTypes.shape({
    id: PropTypes.number.isRequired,
    transactions: PropTypes.arrayOf(
      PropTypes.shape({
        paymentMethod: PropTypes.shape({
          id: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
        }).isRequired,
        creditNoteId: PropTypes.number,
        business: PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
          businessTaxId: PropTypes.string,
        }),
      }),
    ).isRequired,
    manualPaymentMethod: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      transactionCode: PropTypes.string,
    }),
    manualVoucherCode: PropTypes.string,
    customer: PropTypes.shape({
      idDocumentNumber: PropTypes.string,
    }),
    creditNoteTotalAmount: PropTypes.number,
    salePrice: PropTypes.number,
  }).isRequired,
};

TicketPostponeForm.defaultProps = {
  message: '',
  creditNoteMotiveValue: null,
};

const mapStateToProps = (state) => ({
  creditNoteMotiveValue: selector(state, 'creditNoteMotive'),
});

const formComponent = reduxForm({
  form: 'TicketPostponeForm',
})(TicketPostponeForm);

export default connect(mapStateToProps, null)(formComponent);
